module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAAAXNSR0IArs4c6QAAAGRJREFUKFNj3Own8Z8BH/j3r8F3y6tGmBJGkAbfTS8YcekBG4ikiTgNjAxXGf7+Ww2yiTgNMOv//WsgqAHZqSDnoWhADwB0v2FowBtaDAwMlGvAFScwp1FuA8l+GEROIuR2ZHkA23BxrKui05MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fileR.png
// module id = 420
// module chunks = 0